// extracted by mini-css-extract-plugin
module.exports = {"providers__heading":"styles_providers__heading__nZYpv","heading":"styles_heading__7D1fd","text":"styles_text__cOvz1"};